import React from 'react';

import {
  CurrentLoanInfoT,
  isLoanTypeInstallment,
  isLoanTypeLoc,
} from '@consumer-frontend/api';

import { InstallmentNav } from './InstallmentNav';
import { LocNav } from './LocNav';
import { NoLoanNav } from './NoLoanNav';

export type NavSelectionPropsT = {
  loanInfo?: CurrentLoanInfoT;
};

export type NavSelectionT = React.FC<NavSelectionPropsT>;

export const NavSelection: NavSelectionT = ({ loanInfo }) => {
  if (loanInfo && isLoanTypeLoc(loanInfo.loan_type_cd)) {
    return <LocNav />;
  }

  if (loanInfo && isLoanTypeInstallment(loanInfo.loan_type_cd)) {
    return <InstallmentNav />;
  }

  return <NoLoanNav />;
};
